//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import QfMScriptEditor from "./qf-m-script-editor.vue";

export default {
    name: "QfPScriptEditor",
    components: { QfMScriptEditor },
    data() {
        return {
            showModal: false,
            localValue: null,
            currentEdit: null,
            removing: false
        };
    },
    computed: {
        ...mapState("components", ["properties", "activeComponent"]),
        events() {
            return this.properties[this.activeComponent].__events;
        },
        customEvents() {
            return this.properties[this.activeComponent].__customEvents;
        },
        allEvents() {
            return { ...this.events, ...this.customEvents };
        }
    },
    methods: {
        onUpdate(value) {
            if (this.events.hasOwnProperty(this.currentEdit)) {
                this.events[this.currentEdit] = value;
            } else {
                this.customEvents[this.currentEdit] = value;
            }
        },
        add(event) {
            this.currentEdit = event;
            this.localValue = this.events.hasOwnProperty(event) ? this.events[event] || "" : this.customEvents[event] || "";
            this.showModal = true;
        },
        edit(event) {
            this.currentEdit = event;
            this.localValue = this.events.hasOwnProperty(event) ? this.events[event] || "" : this.customEvents[event] || "";
            this.showModal = true;
        },
        remove(event) {
            this.currentEdit = event;
            this.removing = true;
        },
        cancelRemove() {
            this.currentEdit = null;
            this.removing = false;
        },
        doRemove() {
            if (this.events.hasOwnProperty(this.currentEdit)) {
                this.events[this.currentEdit] = null;
            } else {
                this.customEvents[this.currentEdit] = null;
            }

            this.currentEdit = null;
            this.removing = false;
        }
    }
};
